<template>
  <DialogBottomSheet
    eager
    :persistent="persistent"
    :no-click-animation="persistent"
    :is-visible="isVisibleWithDelay"
    :width="isMobile ? '100%' : '360px'"
    @dialog-bottom-sheet:change-visible="$emit('modal:update-visible', $event)"
  >
    <!-- eslint-disable vue/multiline-html-element-content-newline -->
    <v-card>
      <v-card-title class="pb-4">
        <div class="text-h6 text--text">
          Войдите, чтобы продолжить
        </div>
      </v-card-title>
      <v-divider v-if="!isMobile" />
      <div :class="isMobile ? 'px-2' : 'px-4 pt-6'">
        <slot />
      </div>
      <div class="px-4 pt-2 pb-6">
        <div class="text-body-2 text-secondary--text text-center">
          Подтверждая номер, вы даете согласие на
          <a
            href="/info/privacy-policy/"
            class="text-decoration-none primary--text"
            target="_blank"
          >обработку персональных данных</a>
          <br>
          и принимаете
          <a
            href="/info/terms-of-use/"
            class="text-decoration-none primary--text"
            target="_blank"
          >пользовательское соглашение</a><template v-if="usePublishingPolicy">, а также согласны с
            <a
              href="/info/publishing-policy/"
              class="text-decoration-none primary--text"
              target="_blank"
            >политикой публикации материалов</a>
          </template>
        </div>
      </div>
    </v-card>
  </DialogBottomSheet>
</template>

<script>
import DialogBottomSheet from 'www/vue_components/common/core/DialogBottomSheet.vue'

export default {
  name: 'UserAuthorizationModalLayout',
  components: {
    DialogBottomSheet,
  },
  props: {
    persistent: {
      type: Boolean,
      default: false,
    },
    isVisible: {
      type: Boolean,
      default: false,
    },
    usePublishingPolicy: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    isVisibleWithDelay: false,
    isMobile: window.MOBILE_VERSION,
  }),
  watch: {
    isVisible: {
      immediate: true,
      async handler() {
        /**
         * Необходима небольшая задержка перед открытием модалки,
         * чтобы она не мерцала при загрузке страницы.
         */
        await this.$nextTick()

        this.isVisibleWithDelay = this.isVisible
      },
    },
  },
}
</script>

<style lang="scss">
.v-overlay {
  // Значение transition взято из vuetify у v-overlay (за исключением длительности анимации для z-index)
  // Значение 0ms - исправляет анимацию, когда элементы с больши́м z-index отображаются поверх оверлея
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), z-index 0ms;
}
</style>
